export default "__VITE_ASSET__j6Pzj$5A__"